<template>
  <div class="home">
    <div class="_container">
      <div class="main">
        <div class="logo-img">
          <img class="pc-logo" src="../assets/image/logo.png" alt="" />
          <img class="logo-text" src="../assets/image/logo-text.png" alt="" />
        </div>
        <div class="login-container">
          <div class="login-bg">
            <div class="login-tab">
              <div class="tab-item register"></div>
              <!-- <div 
              class="tab-item login"
              :class="{ active: active === 'login' }"
               @click="tabChange('login')"></div> -->
            </div>
            <div class="login-content">
              <Login v-if="active === 'login'" />
              <Register v-else />
            </div>
          </div>
        </div>
      </div>
      <div class="download">
        <div class="down-android down-btn" @click="downAndroid">
          <img src="../assets/image/down-android.png" alt="" />
        </div>
        <div class="down-ios down-btn" @click="downIos">
          <img src="../assets/image/down-ios.png" alt="" />
        </div>
      </div>
      <div class="promo-info">
        <h5>*Quy định trả thưởng</h5>
        <p>
          Sau khi tải xuống và đăng nhập ứng dụng Gi8, vui lòng truy cập [Hội viên - Điểm thưởng], nhấp vào vé xổ số của
          bạn để nhận phần thưởng miễn phí.
        </p>
      </div>
    </div>
    <div class="sidebar-left">
      <img src="../assets/image/nav-left.png" alt="" />
    </div>
    <div class="sidebar-right">
      <div class="sidebar-item">
        <img src="../assets/image/lott.png" alt="" />
      </div>
      <div class="sidebar-item">
        <img src="../assets/image/slot.png" alt="" />
      </div>
      <div class="sidebar-item">
        <img src="../assets/image/live.png" alt="" />
      </div>
      <div class="sidebar-item">
        <img src="../assets/image/sport.png" alt="" />
      </div>
    </div>
    <div class="appModal" v-show="showModal">
      <div class="appModal-content">
        <div class="appModal-bg">
          <img src="../assets/image/appModal.png" alt="" />
        </div>
        <div class="app-qrcode">
          <div class="app-ios" v-if="appType === 'ios'">
            <div class="qrcode-ios">
              <vue-qr :text="downLink.MOBILECONFIG.url" :size="150" :margin="0"></vue-qr>
            </div>
            <div class="ios-icon">
              <img src="../assets/image/ios.png" alt="" />
            </div>
          </div>
          <div class="app-android" v-if="appType === 'android'">
            <div class="qrcode-android">
              <vue-qr :text="downLink.Android.url" :size="150" :margin="0"></vue-qr>
            </div>
            <div class="android-icon">
              <img src="../assets/image/android.png" alt="" />
            </div>
          </div>
        </div>
        <span class="close" @click="closeAppModal">
          <img src="../assets/image/icon-close.png" alt="" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "./Login";
import Register from "./Register";
import { isMobile } from "../utils/utils";
import VueQr from "@/components/vueQr";
export default {
  components: {
    Login,
    Register,
    VueQr,
  },
  data() {
    return {
      active: "register",
      showModal: false,
      appType: "",
    };
  },
  computed: {
    downLink() {
      return this.$store.state.downLink;
    },
  },
  methods: {
    tabChange(tab) {
      this.active = tab;
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    closeAppModal() {
      this.showModal = false;
    },
    getStatus() {
      let data = {
        device: "MOBILE",
        track: "standalone" in window.navigator && window.navigator.standalone ? 0 : undefined,
      };
      this.$store.dispatch("getStatus", data);
    },
    downApp(link) {
      if (link) {
        let a = document.createElement("a");
        a.href = link;
        a.click();
      }
    },
    downAndroid() {
      let link = this.downLink["Android"]["url"];
      if (!isMobile()) {
        if (link) {
          this.appType = "android";
          this.showModal = true;
        }
      } else {
        this.downApp(link);
      }
    },
    downIos() {
      let link = this.downLink["MOBILECONFIG"]["url"];
      if (!isMobile()) {
        if (link) {
          this.appType = "ios";
          this.showModal = true;
        }
      } else {
        this.downApp(link);
      }
    },
    showAlert() {
      this.$loading.show();
    },
  },
  created() {
    this.getStatus();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  min-height: 100%;
  background: url("../assets/image/background_web.jpg") no-repeat center/cover fixed;
  position: relative;
  overflow-x: hidden;
  .sidebar-left {
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    img {
      display: block;
      height: 100%;
    }
  }
  .sidebar-right {
    display: flex;
    flex-direction: column;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    .sidebar-item {
      margin-bottom: 5px;
      img {
        display: block;
        height: 150px;
      }
    }
  }
  ._container {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .main {
    width: 100%;
    margin: 0 auto;
  }
  .logo-img {
    .pc-logo {
      display: block;
      margin: 0 auto;
      width: 70%;
    }
    .logo-text {
      width: 90%;
      margin-top: -30px;
    }
  }
  .download {
    max-width: 310px;
    margin: 50px auto 20px;
    .down-btn {
      cursor: pointer;
    }
    .down-ios {
      margin-top: 20px;
    }
    img {
      display: block;
      width: 100%;
    }
  }
  .promo-info {
    max-width: 550px;
    margin: 0 auto 30px;
    padding: 0 30px;
    h5 {
      font-size: 18px;
      color: #65d105;
      text-align: center;
    }
    p {
      line-height: 20px;
      font-size: 14px;
      color: #fff;
      white-space: pre-wrap;
    }
  }
  .login-container {
    width: 100%;
    margin: 0 auto;
    padding: 0 10px;
    .login-bg {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 280px;
      margin: 0 auto;
      background-image: url("../assets/image/login-bg.png");
      background-size: 100% 100%;
    }
    .login-tab {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;
      padding: 0 52px 6px;
      background: url("../assets/image/tab-bg.png");
      background-size: 100% 100%;
    }
    .login-content {
      flex: 1;
      align-items: center;
      position: relative;
      padding: 20px 20px 50px;
    }
    .tab-item {
      width: 65%;
      height: 40px;
      background-size: 100% 100%;
    }
    // .tab-item.login {
    //   background-image: url("../assets/image/login-off.png");
    //   &.active {
    //     background-image: url("../assets/image/login-on.png");
    //   }
    // }
    .tab-item.register {
      background-image: url("../assets/image/register-btn.png");
      // &.active {
      //   background-image: url("../assets/image/register-on.png");
      // }
    }
  }
  .appModal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    background: rgba(0, 22, 53, 0.6);
    .appModal-content {
      width: 440px;
      height: 400px;
      margin: 0 auto;
      position: relative;
      transform: translateY(-50%);
      top: 55%;
      .appModal-bg {
        position: absolute;
        left: -140px;
        top: -100px;
        img {
          display: block;
          width: 700px;
        }
      }
      .close {
        position: absolute;
        right: -35px;
        top: 60px;
        z-index: 200;
        cursor: pointer;
      }
    }
    .app-qrcode {
      position: relative;
      z-index: 100;
      padding-top: 155px;
      display: flex;
      justify-content: center;
      .qrcode-ios,
      .qrcode-android {
        width: 170px;
        height: 170px;
        padding: 10px;
        border-radius: 5px;
        background-color: #fff;
      }
      .ios-icon,
      .android-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        margin-top: 5px;
        img {
          height: 35px;
        }
      }
    }
  }
  @media (min-width: 550px) {
    .main {
      max-width: 480px;
    }
    .login-container {
      .login-content {
        padding: 30px 43px 50px;
      }
    }
  }
  @media (max-width: 1024px) {
    .sidebar-left,
    .sidebar-right {
      display: none;
    }
  }
}
</style>
